import {
  Component,
  OnInit,
  ViewContainerRef,
  HostListener,
} from '@angular/core';
import { ApiService } from './services/api.service';
import { Router } from '@angular/router';
import { Onboarding, Status } from './models/onboarding';
import { ModalDialogService } from 'ngx-modal-dialog';
import { UtilsService } from './services/utils.service';
import { AlgExitPopupComponent } from './components/dialogs/alg-exit-popup/alg-exit-popup.component';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  public onboarding: Onboarding = {} as Onboarding;
  public isMobile = false;
  public isDesktop = false;
  public actualWidth: number;
  public exitPopupAlreadyShown = false;

  constructor(
    private api: ApiService,
    private router: Router,
    private modalDialogService: ModalDialogService,
    private utils: UtilsService,
    private viewContainer: ViewContainerRef
  ) {}

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    if (event.target.innerWidth <= 767) {
      this.isMobile = true;
      this.isDesktop = false;
    } else {
      this.isMobile = false;
      this.isDesktop = true;
    }
  }

  public ngOnInit() {
    this.actualWidth = window.innerWidth;

    if (this.actualWidth <= 767) {
      this.isMobile = true;
      this.isDesktop = false;
    } else {
      this.isMobile = false;
      this.isDesktop = true;
    }

    this.api.currentOnboarding.subscribe((onb) => {
      this.onboarding = onb;
    });
    return this.api
      .checkWipStatus()
      .toPromise()
      .then((data: any) => {
        if (data.status)
          return this.router.navigateByUrl('/maintenance-period');
      })
      .catch((err) => {
        console.log(err);
      });
  }

  // Trigger whenever user leaves the window with mouse
  public openExitPopUp($event) {
    if (
      this.onboarding.webStatus === Status.userInfo &&
      this.isDesktop &&
      !this.exitPopupAlreadyShown &&
      ($event.y <= 0 || // This value will be negative whenever the mouse will leave viewPort on top
        $event.x <= 0 || // This value will be negative whenever the mouse will  leave viewPort on left
        $event.x >= window.innerWidth || // This value will be greater then the viewport width whenever the mouse will leave viewPort on the right
        $event.y >= window.innerHeight) // This value will be greater then the viewport height whenever the mouse will leave viewPort on the right
    ) {
      this.utils.disableOverflow();
      this.modalDialogService.openDialog(this.viewContainer, {
        childComponent: AlgExitPopupComponent,
        settings: {
          closeButtonClass: 'close theme-icon-close',
          modalClass: 'modal fade ngx-modal ngx-modal exit-popup-modal',
        },
        data: {},
      });
      this.exitPopupAlreadyShown = true;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts